var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcTrasactions = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1F1D0D",
    d: "M4.194 6.129a1.935 1.935 0 1 1 0-3.87 1.935 1.935 0 0 1 0 3.87zm0-6.129a4.198 4.198 0 0 1 4.193 4.194 4.198 4.198 0 0 1-4.193 4.193A4.198 4.198 0 0 1 0 4.194 4.198 4.198 0 0 1 4.194 0zm0 6.774a2.584 2.584 0 0 0 2.58-2.58 2.584 2.584 0 0 0-2.58-2.581 2.584 2.584 0 0 0-2.581 2.58 2.584 2.584 0 0 0 2.58 2.581z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8D822",
    d: "M15.806 17.742a1.935 1.935 0 1 1 0-3.871 1.935 1.935 0 0 1 0 3.87zm0-6.13A4.198 4.198 0 0 1 20 15.807 4.198 4.198 0 0 1 15.806 20a4.198 4.198 0 0 1-4.193-4.194 4.198 4.198 0 0 1 4.193-4.193zm0 6.775a2.584 2.584 0 0 0 2.581-2.58 2.584 2.584 0 0 0-2.58-2.581 2.584 2.584 0 0 0-2.581 2.58 2.584 2.584 0 0 0 2.58 2.581z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141101",
    d: "M14.17 2.557l-1.86 1.86h2.851a3.007 3.007 0 0 1 3.004 3.002v1.936a.423.423 0 0 1-.846 0V7.419a2.16 2.16 0 0 0-2.158-2.158h-2.85l1.859 1.86a.422.422 0 1 1-.598.597l-2.58-2.58a.422.422 0 0 1 0-.598l2.58-2.58a.422.422 0 1 1 .598.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8D822",
    d: "M4.839 14.739h2.85l-1.859-1.86a.422.422 0 1 1 .598-.597l2.58 2.58a.422.422 0 0 1 0 .598l-2.58 2.58a.422.422 0 1 1-.598-.597l1.86-1.86H4.839a3.007 3.007 0 0 1-3.004-3.002v-1.936a.423.423 0 0 1 .846 0v1.936a2.16 2.16 0 0 0 2.158 2.158z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcTrasactions, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-trasactions.3bc3ccec.svg";
export { ForwardRef as ReactComponent };